module.exports = __webpack_public_path__ + "img/lisa_profile.2961cab4.png";